<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  [style]="{width: '800px'}"
  styleClass="p-fluid modifica-note-intervento-dialog"
  [showHeader]="false"
  (onHide)="hide()">

  <div class="dialog-container">
    <div class="dialog-header">
      <div class="header-content">
        <i class="pi pi-pencil header-icon"></i>
        <h2>Modifica Note Intervento</h2>
        <div class="code-badge" style="background-color: #f5f5f5; padding: 0.25rem 0.5rem; border-radius: 4px; margin-left: 1rem;">
          <span class="code-value" style="font-weight: bold; color: #3a6e75;">{{ intervento?.scheda?.codice | uppercase }}</span>
        </div>
      </div>
      <button
        pButton
        pRipple
        icon="pi pi-times"
        class="p-button-rounded p-button-text close-btn"
        (click)="hide()">
      </button>
    </div>

    <div class="dialog-content">
      <div class="form-content">
        <!-- <div class="info-section" style="margin-bottom: 1.5rem; padding: 1rem; background: #f8f9fa; border-radius: 8px;">
          <div style="display: flex; gap: 2rem; flex-wrap: wrap;">
            <div style="flex: 1; min-width: 200px;">
              <div style="font-size: 0.85rem; color: #666; margin-bottom: 0.25rem;">Anno</div>
              <div style="font-weight: 600; color: #333;">{{ intervento?.richiesta?.anno }}</div>
            </div>
            <div style="flex: 1; min-width: 200px;">
              <div style="font-size: 0.85rem; color: #666; margin-bottom: 0.25rem;">Ente Esecutore</div>
              <div style="font-weight: 600; color: #333;">{{ intervento?.richiesta?.enteEsecutore?.label | uppercase }}</div>
            </div>
            <div style="flex: 1; min-width: 200px;">
              <div style="font-size: 0.85rem; color: #666; margin-bottom: 0.25rem;">Stato</div>
              <div style="font-weight: 600; color: #333;">{{ intervento?.stato?.descrizione | uppercase }}</div>
            </div>
          </div>
        </div> -->

        <div class="form-group">
          <label for="note" style="display: block; margin-bottom: 0.5rem; font-weight: 600; color: #333;">
            <i class="pi pi-file-edit" style="margin-right: 0.5rem;"></i>
            Note
          </label>
          <textarea
            id="note"
            pInputTextarea
            [(ngModel)]="noteCorrente"
            [rows]="8"
            [cols]="30"
            [style]="{'width': '100%', 'font-size': '0.95rem'}"
            placeholder="Inserisci eventuali note relative all'intervento..."
            [disabled]="submitting">
          </textarea>
          <small style="display: block; margin-top: 0.5rem; color: #666; font-style: italic;">
            Le note possono essere modificate in qualsiasi momento, indipendentemente dallo stato dell'intervento
          </small>
        </div>
      </div>
    </div>

    <div class="dialog-footer">
      <button
        pButton
        pRipple
        label="Annulla"
        icon="pi pi-times"
        class="p-button-outlined p-button-secondary"
        (click)="hide()"
        [disabled]="submitting">
      </button>
      <button
        pButton
        pRipple
        label="Conferma"
        icon="pi pi-check"
        class="p-button-primary"
        (click)="salva()"
        [disabled]="noteNonModificate || submitting"
        [loading]="submitting">
      </button>
    </div>
  </div>
</p-dialog>

<p-toast position="top-right"></p-toast>
